
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 25","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15 3.209a2.75 2.75 0 00-2.75 2.75v.539l-.72-.72a2.75 2.75 0 00-1.944-.805c-.756 0-1.501.362-1.997.858L4.814 8.606a2.75 2.75 0 000 3.889l.713.714H5a2.75 2.75 0 00-2.75 2.75v4A2.75 2.75 0 005 22.709h12a4.75 4.75 0 004.75-4.75v-12A2.75 2.75 0 0019 3.209h-4zm-10 11.5h2.027l6.5 6.5H5a1.25 1.25 0 01-1.25-1.25v-4A1.25 1.25 0 015 14.709zm14.298 5.548a3.25 3.25 0 01-5.548-2.298v-12A1.25 1.25 0 0115 4.709h4a1.25 1.25 0 011.25 1.25v12a3.25 3.25 0 01-.952 2.298zM12.25 17.81V8.62l-1.78-1.78v-.001a1.25 1.25 0 00-.884-.366c-.305 0-.681.164-.936.418L5.874 9.667a1.25 1.25 0 000 1.767l6.376 6.376zm5.75.149a1 1 0 10-2 0v.01a1 1 0 102 0v-.01z"}})])
          )
        }
      }
    